
<template>
    <div>

        <div class="row">

            <div class="col-lg-2">
                <h3 class="mb-0 text-uppercase">Basic Details</h3>
            </div>

            <div class="col-lg-12">
                <hr class="my-4" />
            </div>

            <div class="col-lg-8" v-if="application">

                <h3>
                    Application Date - &nbsp;&nbsp;&nbsp;
                    {{ application.application_date | formatDate }}
                </h3>

                <h3>
                    Application Status - &nbsp;&nbsp;&nbsp;
                    <badge size="sm"
                        :type="getStatusColor(application.status)"
                    >
                        {{ application.status }}
                    </badge>
                </h3>

                <h3>
                    Payment Status - &nbsp;&nbsp;&nbsp;
                    <badge size="sm"
                        :type="getPaymentStatusColor(application.payment_status)"
                    >
                        {{ application.payment_status }}
                    </badge>
                </h3>

                <h3
                    v-if="(application.status == 'rejected') || (application.status == 'approved')"
                    class="text-capitalize"
                >
                    {{ application.status }} Date - &nbsp;&nbsp;&nbsp;
                    {{ application.approved_date | formatDate }}
                </h3>

                <h3
                    v-if="(application.status == 'rejected')"
                    class="text-capitalize"
                >
                    Reject Reason - &nbsp;&nbsp;&nbsp;
                    <small class="text-danger">{{ application.reject_reason }}</small>
                </h3>

                <h3
                    v-if="(application.status == 'approved')"
                    class="text-capitalize"
                >
                    Expiry Date - &nbsp;&nbsp;&nbsp;
                    {{ application.expiry_date | formatDate }}
                </h3>

                <h3
                    v-if="(application.status == 'approved')"
                    class="text-capitalize"
                >
                    Approved Quota - &nbsp;&nbsp;&nbsp;
                    {{ application.quota }}
                </h3>

                <h3 v-if="(application.visit_status == 'yes')">
                    Verification Visit Status - &nbsp;&nbsp;&nbsp;
                    <badge size="sm" type="success">
                        {{ application.visit_status }}
                    </badge>
                </h3>

                <h3 v-if="(application.visit_status == 'yes')">
                    <hr>
                    Verification Visit Comment - &nbsp;&nbsp;&nbsp;
                    <em class="text-danger">{{ application.visit_comment }}</em>
                </h3>

                <h3 v-if="application.notify_date" class="text-capitalize">
                    Fixed Visitation Date - &nbsp;&nbsp;&nbsp;
                    {{ application.notify_date | formatDate }}
                </h3>

                <h3 v-if="application.notify_date && application.notify_comment" class="text-capitalize">
                    Visitation Additional Comment - &nbsp;&nbsp;&nbsp;
                    <em class="small">{{ application.notify_comment }}</em> 
                </h3>
                <br>

                <base-button
                    size="lg"
                    type="primary"
                    @click="$emit('displayVisitationDatePage', true)"
                    v-if="(application.status == 'submitted')"
                >
                    <i class="fa fa-bullhorn"></i>
                    {{ application.notify_date ? 'Change' : 'Notify' }} Visitation Date
                </base-button>

                <form 
                    @submit.prevent="printHospitalLetter"
                    v-if="(application.status == 'approved') && application.letter"
                >
                <!-- <form
                    :action="getRootUrl+'/print-hospital-letter'"
                    method="POST"
                    target="_blank"
                    v-if="(application.status == 'approved') && application.letter"
                > -->
                    <!-- <input type="hidden" name="id" :value="application.id" />
                    <input type="hidden" name="authorization_token" :value="getAuthorizationToken" />
                    <input type="hidden" name="user_id" :value="user.id" /> -->
                    <input type="hidden" name="option" value="admin" />
                    <input type="hidden" name="date" :value="application.approved_date" />
                    <input type="hidden" name="ref_no" :value="application.letter.ref_no" />
                    <input type="hidden" name="plenary" :value="application.letter.plenary" />
                    <input type="hidden" name="plenary_date" :value="application.letter.plenary_date" />
                    <input type="hidden" name="plenary_venue" :value="application.letter.plenary_venue" />
                    <input type="hidden" name="visit_date" :value="application.letter.visit_date" />
                    <input type="hidden" name="quota" :value="application.letter.quota" />
                    <input type="hidden" name="last_quota" :value="application.letter.last_quota" />

                    <hr>
                    <base-button
                        type="primary"
                        class="btn btn-lg"
                        nativeType="submit"
                    >
                        <i class="fa fa-print"></i>
                        {{ isLoading ? 'Please Wait...' : 'Print Letter'}}
                    </base-button>
                </form>
                <br>

            </div>

            <div class="col-lg-4">
                <div class="card-profile-image marginTop40">
                    <img
                        :src="photoUrl"
                        class="rounded-circle"
                    >
                </div>
                <br><br><br><br><br>
            </div>

            <div class="col-lg-12">
                <hr class="my-4" />
            </div>
        </div>

    </div>
</template>
<script>
    import moment from 'moment';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'BasicDetails',
        props: ['application'],
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        data() {
            return {
                isLoading: false
            }
        },
        computed: {
            ...mapGetters(['user', 'getPrintHospitalLetterUrl', 'blankImageUrl']),
            photoUrl() {
                return this.application && this.application.photo ? this.application.photo.image : this.blankImageUrl;
            }
        },
        methods: {
            ...mapActions(['downloadAssessmentFiles']),
            getStatusColor(value) {
                if(value == 'approved') {
                    return 'success';
                } else if(value == 'submitted') {
                    return 'warning';
                } else {
                    return 'danger'
                }
            },
            getPaymentStatusColor(value) {
                return (value == 'paid') ? 'success' : 'danger';
            },
            printHospitalLetter(event) {
                this.isLoading = true;
                const formData = new FormData(event.target);
                const payload = Object.fromEntries(formData.entries());// get entries

                const data = { 
                    ...payload,
                    id: this.application.id, 
                    user_id: this.user.id,
                    url : this.getPrintHospitalLetterUrl,
                    contentType : 'application/pdf',
                    fileName :  'hospital-letter.pdf',
                    msg : 'Failed to export Hospital Letter:'
                };
                return this.downloadAssessmentFiles(data).then((res) => {// download file
                    this.isLoading = res; // stop loading
                });
            }
        }
    };
</script>
<style scoped>
    .marginTop40 {
        margin-top: 40px;
    }
    .right {
        float: right;
    }
    .marginLeft5 {
        margin-left: 5px;
    }
</style>
